// The commented-out CSS cheat sheet shown in an empty CSS editor. Every
// snippet is wrapped in its own comment block so "uncomment and tweak" is
// one deletion away. A buffer that still equals the scaffold (or is blank)
// is treated as empty at save time — browsing the cheat sheet persists
// nothing. Keep this in lockstep with docs/theming.md — the internal source
// of the styling contract; customers only ever see THIS scaffold, so no
// customer-visible text may reference repo paths.

const COMMON = `/* Make everything bigger or smaller together.
.ewt-screen {
    font-size: 14vh;
}
*/

/* Colors and font — the quick knobs the built-in styles read.
.ewt-screen {
    --ewt-bg: #101014;
    --ewt-text: #f4f4f5;
    --ewt-value-color: #ffb400;
    --ewt-font: "Inter", system-ui, sans-serif;
}
*/

/* Space between pieces, and the padding around the edge of the screen.
   Both are sized against the screen's height rather than the text size,
   so they stay the same no matter how big or small a nearby piece is.
.ewt-screen {
    --ewt-gap: 2vh;
    --ewt-pad: 4vh;
}
*/

/* Every text piece, in one shot.
.ewt-section[data-type="text"] {
    font-size: 0.4em;
    text-transform: uppercase;
}
*/

/* Pull one piece off to the side instead of the shared center line — e.g.
   a logo hard against the left edge in a Column layout. Copy the piece's
   handle from the editor — the small #s3 button beside it.
.ewt-section[data-section="s3"] {
    align-self: flex-start;
}
*/

/* Move one piece to the front of the line, ahead of the order you placed
   it in when authoring the template (a higher number moves it toward the
   back instead).
.ewt-section[data-section="s1"] {
    order: -1;
}
*/

/* A logo's size (an image piece keeps its aspect ratio). This is the
   ratio most likely to need adjusting — it depends on your own
   wordmark's proportions.
.ewt-section-image {
    max-height: 1.4em;
}
*/

/* Hide the unit label next to the value.
.ewt-unit {
    display: none;
}
*/

/* Reveal an unassigned image piece (the attribute must be repeated
   here — a base rule using an attribute can't be overridden by a bare
   class).
.ewt-section-image[data-empty="true"] {
    display: block;
}
*/

/* Stale data (updates failing for a few minutes): keep the value
   fully opaque instead of the built-in dimming.
.ewt-screen[data-state="stale"] .ewt-value {
    opacity: 1;
}
*/`;

export const TEMPLATE_CSS_SCAFFOLD = `/* ============================================================
   Template CSS — shared by every screen using this template.
   Each block below is commented out: remove the wrapping
   comment markers to activate it, then tweak. Anything you
   leave commented is free.
   ============================================================ */

${COMMON}

/* ------------------------------------------------------------
   Self-hosted brand assets: if you host fonts and images on your
   own domain or CDN, reference them by URL — no upload needed.
   ------------------------------------------------------------ */

/* A brand font from your own server (woff2 recommended).
@font-face {
    font-family: "Brand";
    src: url("https://assets.example.com/brand.woff2") format("woff2");
    font-display: swap;
}
.ewt-screen {
    --ewt-font: "Brand", system-ui, sans-serif;
}
*/

/* A background image from your own server (it is scaled to
   cover the screen and centered automatically).
.ewt-screen {
    background-image: url("https://assets.example.com/backdrop.jpg");
}
*/

/* A logo from your own server: reveal the (empty) image piece and
   paint your image into it. Works when no image is uploaded.
.ewt-section-image[data-empty="true"] {
    display: block;
    min-height: 18vmin;
    min-width: 30vmin;
    background: url("https://assets.example.com/logo.svg") center / contain no-repeat;
}
*/
`;

/** True when the buffer would persist nothing: blank, or the untouched scaffold. */
export function isPristineCss(value: string, scaffold: string): boolean {
    const trimmed = value.trim();
    return trimmed === "" || trimmed === scaffold.trim();
}
